import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { SimpleInputModule } from '@hglobal/fin-ui';
import { TranslateModule } from '@ngx-translate/core';

import { TooltipComponent } from '@iw/common';

@Component({
  selector: 'iw-crypto-form',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    SimpleInputModule,
    TranslateModule,
    TooltipComponent,
  ],
  templateUrl: './crypto-form.component.html',
  styleUrl: './crypto-form.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CryptoFormComponent {
  form = input<FormGroup>();
}
